<template>
  <v-container class="full-height-container px-6">
    <v-row>
      <v-col cols="12" class="d-flex align-center flex-column login-container">
        <v-img
            v-if="isLogoBase64 || !customLogo"
            :width="$vuetify.breakpoint.mobile ? 171 : 200"
            :height="$vuetify.breakpoint.mobile ? 60 : 60"
            contain
            :src="customLogo ? customLogo : require(`@/assets/logo${isDark ? '-white' : ''}.svg`)"
            class="mb-10"
        ></v-img>
        <div v-else v-html="customLogo" class="mb-10 d-flex" 
               
            >
            </div>
        <v-card elevation="4" class="d-flex">
          <v-card-title class="d-flex justify-center">
            <h1 class="font-weight-800 text-center">{{ $t('heading.resetPasswordPage.title') }}</h1>
          </v-card-title>
          <v-card-text>
            <v-form class="form">
              <v-text-field
                outlined
                class="v-input--lg"
                :label="$t('form.placeholder.passwordNew')"
                type="password"
                :rules="adminPasswordRules"
                v-model="password"
                solo
                flat
                hide-details="auto"
                validate-on-blur
            >
              <template v-slot:prepend-inner>
                <v-icon color="headings--text">$lockoutline</v-icon>
              </template>
            </v-text-field>
              <v-text-field
                  outlined
                  class="v-input--lg"
                  :label="$t('form.label.passwordConfirm')"
                  type="password"
                  :rules="adminPasswordRules"
                  v-model="confirmedPassword"
                  solo
                  flat
                  hide-details="auto"
                  validate-on-blur
              >
                <template v-slot:prepend-inner>
                  <v-icon color="headings--text">$lockoutline</v-icon>
                </template>
              </v-text-field>
            </v-form>
            <v-btn
                x-large
                @click="resetPassword"
                color="primary"
                block
                elevation="0"
                class="mt-6"
            >{{ $t('button.resetPassword') }}</v-btn>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-img
        :src="require('@/assets/illustrations/radio-lines.svg')"
        class="radio-lines"
    />
  </v-container>
</template>

<script>
import FormRulesMixin from "../mixins/FormRulesMixin";
import Api from "@/apis/Api";

export default {
  name: "ResetPassword.vue",
  mixins: [FormRulesMixin],
  data() {
    return {
      password: '',
      confirmedPassword: ''
    }
  },
  computed: {
    isDark() {
      return this.$vuetify.theme.dark;
    },
    customLogo: function () {
      if(this.$vuetify.theme.dark && this.$store.state.ThemeModule.darkLogo) {
        return this.$store.state.ThemeModule.darkLogo
      }

      if(!this.$vuetify.theme.dark && this.$store.state.ThemeModule.lightLogo) {
        return this.$store.state.ThemeModule.lightLogo
      }

      return false
    },
    isLogoBase64: function() {
      return this.customLogo &&  this.customLogo.trim().startsWith('data:image/');
    }
  },
  methods: {
    resetPassword() {
        Api.post('/reset-password',
          {
            token: this.$route.query.token,
            email: this.$route.query.email,
            password: this.password,
            password_confirmation: this.confirmedPassword
          }).then(response => {
          this.$store.dispatch("addAlert", {
            success: true,
            successMessage: response.data.message
          });
          this.$router.push({ path: "/login" });
        }). catch((error) => {
          this.$store.dispatch("addAlert", {
            success: false,
            errorMessage: error.response.data.errors.email[0],
          });
        })
      }
    }
}
</script>

<style src="./Login.scss" lang="scss" scoped />